const matchTextToTerm = (item, value) => {
  return (
    item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
  )
};

const sortItems = (a, b, value) => {
  return (
    a.name.toLowerCase().indexOf(value.toLowerCase()) >
    b.name.toLowerCase().indexOf(value.toLowerCase()) ? 1 : -1
  )
};

const matchClfTargetTextToTerm = (item, value) => {
  return (
    item.targetLabel.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
  )
};

const sortClfTargets = (a, b, value) => {
  return (
    a.targetLabel.name.toLowerCase().indexOf(value.toLowerCase()) >
    b.targetLabel.name.toLowerCase().indexOf(value.toLowerCase()) ? 1 : -1
  )
};

module.exports = {
  matchTextToTerm,
  matchClfTargetTextToTerm,
  sortItems,
  sortClfTargets
}



// WEBPACK FOOTER //
// ./src/helpers/matchers.jsx